import React from 'react';
import PropTypes from "prop-types";

import {Drawer} from "@mui/material";

SidebarMobileContainer.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    headerHeight: PropTypes.string
};

function SidebarMobileContainer({open = false, onClose = () => {}, headerHeight = null, ...props}) {
    return (
        <Drawer
            PaperProps={{
                sx: {
                    width: "80%",
                    height: headerHeight ? `calc(100% - ${headerHeight})` : "100%", marginTop: headerHeight ?? '0'
                },
            }}
            open={open}
            anchor={'right'}
            onClose={onClose}
        >
            {props.children}
        </Drawer>
    );
}

export default SidebarMobileContainer;
